module.exports = __webpack_public_path__ + "img/世界企业体育协会@2x.492928d8.png";